









































































import FooterBar from '@/components/FooterBar.vue'
import Forbidden from '@/components/Forbidden.vue'
import NavBar from '@/components/NavBar.vue'
import baseMixin from '@/mixins/baseMixin'
import mixins from 'vue-typed-mixins'
import NivaChat from './components/NivaChat.vue'
import ThemeRetriever from './components/ThemeRetriever.vue'

export default mixins(baseMixin).extend({
    name: 'App',
    components: {
        NavBar,
        FooterBar,
        Forbidden,
        ThemeRetriever,
        NivaChat
    },
    data() {
        return {
            fab: false,
            nivaUrl: null
        }
    },
    created() {
        console.log(process.env.NODE_ENV)
    }
})
